// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"styles_iconWrapper__lh1HW","iconWrapperKelpie":"styles_iconWrapperKelpie__eOsmq","heading":"styles_heading__avgBW","subtitle":"styles_subtitle__0hAEv"};